<template>
  <div :class="['checkbox-field', { checked }]">
    <FriedIcon v-if="checked" icon="check-mark" class="check-icon" />
  </div>
</template>
<script lang="ts">
import { computed, defineComponent } from 'vue';

export default defineComponent({
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const checked = computed(() => !!parseInt(props.value));

    return {
      checked,
    };
  },
});
</script>
<style lang="scss" scoped>
.checkbox-field {
  display: flex;
  align-items: center;
  justify-content: center;

  .check-icon {
    height: 80%;
    width: 80%;
  }
}
</style>
